/* eslint-disable max-len */
import { ActionRuleParams } from '../../types';
import { formatValidation, getIslandLetter } from '../island-validation-format';
import { getSurroundFinishProfile } from '../../../../helpers';
import { IslandType } from '../../../islands/enums';
import { libLang } from '../../../../lang'
import { NotificationType } from '../../../notifications/enums';

// Ceiling for non-MOK families (standard/slat share the Bar preset below); MOK's own Bar preset (40") raises it per island.
const DEFAULT_MAX_HEIGHT = 39.25;

export const islandHeightLimit = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { islands } = refMap.kitchen.design ?? refMap
	// const countertopMaterial = refMap.countertop.material
	const { edge, thickness } = refMap.kitchen.material.countertop

	const { notifications } = refMap.kitchen.design
	let i = 0;

	notifications.purgeReferences(libLang.validations.island.size.height);
	notifications.purgeReferences(libLang.validations.island.size.sameHeight);

	if (!islands || !islands.children) return

	islands?.children?.forEach((island) => {
		// Chiseled edge tops cannot touch unless they are side-by-side
		if (edge === 'chiseled') {
			island.connections.children.forEach((connection) => {
				if (!connection.targetIsland) return;
				const targetIsland = islands.findById(connection.targetIsland.id);
				if (!targetIsland) return;
				const { padding } = connection
				if (i === 0 && targetIsland.axis.y !== island.axis.y && padding <= 1 && (Math.abs(targetIsland.size.height - island.size.height) < thickness)) {
					notifications.add({
						refId: island.id,
						validationCode: libLang.validations.island.size.sameHeight,
						description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, issue: `${edge} countertops not allowed on same-height adjoining islands` }),
						type: NotificationType.Warn
					})
					i++
				}
			})
		}
		// islandHeights.push(island.size.height);

		const maxHeight = getSurroundFinishProfile(island.surround?.material)?.islandDimensions[IslandType.Bar]?.height ?? DEFAULT_MAX_HEIGHT;

		if (island.size.height > maxHeight) {
			notifications.add({
				refId: island.id,
				validationCode: libLang.validations.island.size.height,
				description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, issue: `Height ${island.size.height}" exceeds the ${maxHeight}" limit` }),
				type: NotificationType.Warn
			})
		}
	})
}
